import React, { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { modals } from 'helpers'
import Media from 'local_modules/Media'

import Box from 'components/layout/Box/Box'
import Link from 'components/ui/Link/Link'
import Text from 'components/typography/Text/Text'
import Modal from 'components/Modal/Modal'
import Button from 'components/ui/Button/Button'
import { Grid, Cell } from 'components/layout/grid'
import WidthContainer from 'components/WidthContainer/WidthContainer'

import s from './TextModal.scss'


class TextModal extends PureComponent {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: modals.Text,
  }

  close = () => {
    const { name } = this.props

    actions.modals.close(name)
  }

  handleButtonClick = () => {
    const { data: { onButtonClick } } = this.props

    this.close()

    if (typeof onButtonClick === 'function') {
      onButtonClick()
    }
  }

  render() {
    const { data: { image, title, source, sourceLink, date, time, description, buttonTitle } } = this.props

    return (
      <Modal textContainerClassName={s.modal} onClose={this.close}>
        <Media mobile>
          {
            (isMobile) => {
              const WrapperComponent = isMobile ? WidthContainer : Fragment

              return (
                <Fragment>
                  {
                    Boolean(image) && (
                      <img
                        className={s.image}
                        src={`${image}&w=580`}
                      />
                    )
                  }
                  <WrapperComponent>
                    {
                      Boolean(source && date && time) && (
                        <Box pt="8">
                          <Grid columns={2}>
                            <Cell size={1}>
                              {
                                Boolean(sourceLink) ? (
                                  <Link
                                    toTAB={sourceLink}
                                    onClick={(event) => {
                                      event.preventDefault()
                                      event.stopPropagation()
                                      window.open(sourceLink, '_blank')
                                    }}
                                  >
                                    <Text
                                      message={`Источник: ${source}`}
                                      size="12-14"
                                    />
                                  </Link>
                                ) : (
                                  <Text
                                    message={`Источник: ${source}`}
                                    size="12-14"
                                  />
                                )
                              }
                            </Cell>
                            <Cell size={1}>
                              <Text
                                message={`${date} ${time}`}
                                size="12-14"
                                tag="div"
                                right
                              />
                            </Cell>
                          </Grid>
                        </Box>
                      )
                    }
                    <Box pt="16">
                      <Text
                        message={title}
                        size="18-21"
                        color="darkGray"
                        align="justify"
                        weight="semibold"
                      />
                    </Box>
                    <Box pt="16">
                      <Text
                        message={description}
                        size="18-21"
                        align="justify"
                        color="darkGray"
                      />
                    </Box>
                    <Box pt="24">
                      <Button
                        title={buttonTitle || 'Закрыть'}
                        green
                        fullWidth
                        onClick={this.handleButtonClick}
                      />
                    </Box>
                  </WrapperComponent>
                </Fragment>
              )
            }
          }
        </Media>
      </Modal>
    )
  }
}


export default TextModal
